<script lang="ts">import { InfoCard } from "@infinitro/info-card";
export let contentPadding = undefined;
</script>

<InfoCard width="100%" borderRadius="20px" noPadding>
	<div class="vip-benefits-card-content" style={`padding: ${contentPadding};`}>
		<slot />
	</div>
</InfoCard>

<style>
	.vip-benefits-card-content {

		display: flex;

		min-height: 280px;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 2rem;

		padding: 1rem
}

	@media (min-width: 1024px) {
		.vip-benefits-card-content {

				height: 515px;

				padding-left: 6rem;

				padding-right: 6rem;

				padding-top: 3rem;

				padding-bottom: 3rem
		}
	}
</style>
